// Version check utility - forces browser to reload when new version is deployed
const VERSION_KEY = 'app_version';
const CHECK_INTERVAL = 60000; // Check every 60 seconds

export const checkForUpdates = async () => {
  try {
    // Add timestamp to prevent caching of version.json
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    
    if (!response.ok) return;
    
    const data = await response.json();
    const currentVersion = localStorage.getItem(VERSION_KEY);
    
    if (!currentVersion) {
      // First visit - store version
      localStorage.setItem(VERSION_KEY, data.version);
      return;
    }
    
    if (currentVersion !== data.version) {
      // New version available - clear cache and reload
      console.log(`New version available: ${data.version} (current: ${currentVersion})`);
      
      // Update stored version
      localStorage.setItem(VERSION_KEY, data.version);
      
      // Clear all caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      
      // Force hard reload
      window.location.reload(true);
    }
  } catch (error) {
    console.log('Version check failed:', error);
  }
};

export const startVersionCheck = () => {
  // Check immediately on load
  checkForUpdates();
  
  // Then check periodically
  setInterval(checkForUpdates, CHECK_INTERVAL);
};

export const clearAppCache = async () => {
  // Clear localStorage version to force refresh on next check
  localStorage.removeItem(VERSION_KEY);
  
  // Clear all caches
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(name => caches.delete(name)));
  }
  
  // Force reload
  window.location.reload(true);
};
